import React from 'react';
import './AiPresetImportModal.css';
import AiSparkIcon from '../common/AiSparkIcon';
import { useAiAccess } from '../../hooks/useAiAccess';

/** 섹션 오른쪽 위 'AI 자료 입력' 버튼 — 앱 공통 무지개 테두리 AI 버튼 */
const AiPresetOpenButton: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled }) => {
  const { canPlan } = useAiAccess();
  if (!canPlan('ai_curriculum_input')) return null;
  return (
  <button type="button" className="cp-ai-feedback-btn cp-aip-open-btn" onClick={onClick} disabled={disabled} title="사진으로 AI 자료 입력">
    <AiSparkIcon />
    AI 자료 입력
  </button>
  );
};

export default AiPresetOpenButton;
